import React, { FunctionComponent } from 'react';
import {
  Card as MuiCard,
  CardContent,
  CardActions,
  Typography,
  CardProps as MuiCardProps
} from '@mui/material';

const CARD_VARIANTS = ['elevation', 'outlined'] as const;
type CardVariant = typeof CARD_VARIANTS[number];

interface CardProps extends Omit<MuiCardProps, 'variant'> {
  title?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  variant?: CardVariant;
  elevation?: number;
}

export const Card: FunctionComponent<CardProps> = React.memo(({
  title,
  children,
  actions,
  variant = 'elevation',
  elevation = 1,
  className = '',
  ...props
}) => {
  const ErrorFallback: React.FC = () => (
    <MuiCard variant="outlined" className={className}>
      <CardContent>
        <Typography color="error">
          Error rendering card content
        </Typography>
      </CardContent>
    </MuiCard>
  );

  try {
    return (
      <MuiCard 
        variant={variant} 
        elevation={elevation} 
        className={className}
        {...props}
      >
        {title && (
          <CardContent>
            <Typography 
              variant="h6" 
              component="div"
              gutterBottom={!!children}
            >
              {title}
            </Typography>
          </CardContent>
        )}
        <CardContent>
          {children}
        </CardContent>
        {actions && (
          <CardActions>
            {actions}
          </CardActions>
        )}
      </MuiCard>
    );
  } catch (error) {
    console.error('Card rendering error:', error);
    return <ErrorFallback />;
  }
});

Card.displayName = 'Card';

export type { CardProps, CardVariant };